import db from '../db';
import { clearUserToken, getUserToken } from '../redux/users/usersActions';
import { NoNetworkError } from './NoNetworkError'

export function fetchWithTimeout(url, options) {

    if (!options)
        options = {
            method: 'GET',
            headers: new Headers({ 'Content-Type': 'application/json' })
        }

    if (!options.headers)
        options.headers = new Headers({});

    let token = getUserToken();
    if (!options.externalRequest && options.token === undefined && token)
        options.headers.append("Authorization", "Bearer " + token)

    let fetchTimeout = options.timeout || 20000;

    let didTimeOut = false;

    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            didTimeOut = true;
            return reject(new Error('Request timed out'));
        }, fetchTimeout);

        fetch(url, options)
            .then(function (response) {
                // Clear the timeout as cleanup
                clearTimeout(timeout);

                if (response.status === 429)//Trop de tentatives répétées à la connexion. Géré plus loin
                    return resolve(response);

                if (response.status === 401) {//Non authentifié
                    db.User.clear().then(() => {
                        location.reload();
                        clearUserToken()
                    })
                }

                if (!didTimeOut && response.ok && response.status !== 550)
                    return resolve(response);

                return response;
            })
            .then((response) => response.json())
            .then((businessError) => {
                throw businessError;
            }).catch(function (err) {
                // Si on détecte que l'on n'a pas de réseau, on renvoie une erreur "générique"
                if (!navigator.onLine)
                    return reject(new NoNetworkError("Appareil hors connexion"));
                // Rejection already happened with setTimeout
                if (didTimeOut) return;
                // Reject with error
                return reject(err);
            });
    }).then(function (response) {
        // Request success and no timeout
        return response;
    }).catch(function (err) {
        // Error: response error, request timeout or runtime error
        throw err;
    })
}
